import React from 'react';
import ReactDOM from "react-dom";
import { Sparkle, X } from 'lucide-react';


const UseExistingTemplateModal = ({ setShowUseTemplateModal, filteredAllTemplates, handlePreviewClick, setSearchTerm, searchTerm, customTemplateUpdation }) => {
  return (
    <div>
      {ReactDOM.createPortal(
        <div className={`fixed inset-0 bg-black bg-opacity-70 z-[88]`} />,
        document.body
      )}

      {ReactDOM.createPortal(
        <div className="fixed inset-0 z-[90] flex items-center justify-center p-4 pointer-events-none">
        <div
          className="pointer-events-auto w-[90vw] sm:w-[70vw] max-w-[700px] h-[80vh] bg-cyan2 rounded-xl border border-black flex flex-col p-4"
        >
          <div className="flex items-center w-full justify-between mb-2">
            <p className="font-bold mx-auto pl-9">Choose From Existing Template</p>
            <button
              type="button"
              aria-label="Close"
              onClick={() => setShowUseTemplateModal(false)}
              className="p-1.5 text-gray-600 hover:text-gray-900 hover:bg-black/10 rounded-lg transition-colors shrink-0"
            >
              <X size={20} />
            </button>
          </div>

          <div className="border border-black bg-white w-full p-4 rounded-md h-[50vh] flex flex-col flex-1">
            <input
              type="text"
              placeholder="Search templates..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full py-2 px-3 border-2 rounded-md mt-2"
            />

            <p className="font-bold text-lg bg-slate-100 mt-4 py-2 px-2 border-b rounded-md">
              Recommended Templates
            </p>

            <div className="mt-2 overflow-y-auto flex-1">
              {filteredAllTemplates.length === 0 ? (
                <div className="text-center py-4 text-gray-500">No templates found</div>
              ) : (
                filteredAllTemplates.map((template, i) => (
                  <div
                    key={i}
                    className={`mx-auto cursor-pointer hover:bg-grey2 
                                w-full sm:w-full max-w-full 
                                flex flex-col sm:flex-row justify-between items-start sm:items-center 
                                py-3 px-1 sm:py-4 sm:px-1 gap-3 sm:gap-0 
                                ${i !== filteredAllTemplates.length - 1 ? 'border-b' : ''}`}
                  >
                    <p className="text-sm sm:text-base p-1">{template.name}</p>

                    <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                      <button
                        className="font-semibold bg-[#530935] text-white py-2 px-6 text-xs rounded-xl w-full sm:w-auto"
                        onClick={(e) => customTemplateUpdation(e, template.id)}
                      >
                        Select
                      </button>

                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePreviewClick(template);
                        }}
                        className="flex justify-center sm:justify-start bg-primary p-[6px] shadow-md rounded-lg items-center gap-1 text-blue-600 hover:text-blue-800 text-sm font-bold transition-colors duration-200 w-full sm:w-auto"
                      >
                        <Sparkle size={14} />
                        Preview
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
        </div>,
        document.body
      )}
    </div>
  )
}

export default UseExistingTemplateModal